import { render, staticRenderFns } from "./newHelpSearch.vue?vue&type=template&id=31af991a&scoped=true"
import script from "./newHelpSearch.vue?vue&type=script&lang=js"
export * from "./newHelpSearch.vue?vue&type=script&lang=js"
import style0 from "./newHelpSearch.vue?vue&type=style&index=0&id=31af991a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af991a",
  null
  
)

export default component.exports